import api from 'api'
import { CACHE_TAG_ZONE_LIST } from 'api/cacheTagTypes'

import { fromZoneMatchApi } from './zonesAdapters'

import type { GeoZoneMatchResponseApi } from 'types/api/zones/zoneMatch'
import type { ZoneMatch } from 'types/modules/zones/zone'

export interface ZoneMatchesArgs {
  latitude: number
  longitude: number
}

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    // Active zones whose boundary contains the point, smallest first; the location forms build their dropdowns from it.
    fetchZoneMatches: build.query<ZoneMatch[], ZoneMatchesArgs>({
      query: ({ latitude, longitude }) => ({ url: '/api/v1/geo-zones/matches', params: { latitude, longitude } }),
      transformResponse: (res: GeoZoneMatchResponseApi[]) => (Array.isArray(res) ? res.map(fromZoneMatchApi) : []),
      providesTags: [CACHE_TAG_ZONE_LIST],
    }),
  }),
})

export const { useFetchZoneMatchesQuery } = extendedApi
